let historyCreatorInstance;
export function SetHistoryCreatorInstance(historyCreator) {
    historyCreatorInstance = historyCreator;
}
export function GetHistoryCreator() {
    return historyCreatorInstance;
}
